<template>
    <div class="h-100" style="padding-bottom: 14px;">
        <div style="height:55px;border-bottom: 1px solid #1e1e1e;padding:8px 0px;" class="filter-fields-in-logs w-100">
            
            <filters-top-bar 
            v-bind="currentDownloadReportProperties"
            @changeSelectedReportComponent="changeSelectedReportComponent">
            </filters-top-bar>

            <button-top-bar
             v-on:click.native="downloadDuplicatesReportData()">
            </button-top-bar>
        </div>
        <div class="ingest-report-div" style="margin-top: 16px;overflow:auto">
            <table class="tabletable-with-border table-scroll small-first-col table-cell-styles"  style="background: transparent;width:100%;">
                <thead style="color: #eee">
                    <tr>
                        <th style="width: 20%;padding-inline-end:50px" class="text-left">{{$t('Filename')}}</th>
                        <th style="width: 10%;padding-inline-end:30px" class="text-left">{{$t('DateTime')}}</th>
                        <th style="width: 10%;text-align:start;padding-inline-end:50px">{{$t('Size')}}</th>
                        <th style="width: 8%;text-align:start;padding-inline-end:10px">{{$t('Duration')}}</th>
                        <th style="width: 20%;padding-inline-end:10px">{{$t('Location')}}</th>
                        <th style="width: 27%;padding-inline-end:10px">{{$t('Catalog Path')}}</th>
                        <th style="width: 5%;text-align:center">{{$t('State')}}</th>
                    </tr>
                </thead>
                <tbody v-if="duplicatesReportData.length > 0">
                    <template v-for="(duplicate,index1) in duplicatesReportData">
                        <tr
                            v-for="asset in duplicate.assets"
                            :key="asset._id"
                            class="ccomm-logs-row show-delete-icon" :class="{activeclass: activeIndex === duplicate._id}" :style="'color:'+getRandomColorFromUtils(index1)">
                            <td class="text-left">
                                <span v-if="asset.file_name">{{ asset.file_name }}</span>
                                <span v-else class="validationmessage">No Data found</span>
                            </td>

                            <td>
                                <!-- <span v-if="Object.keys(asset).includes('created_datetime') && asset.created_datetime.length > 0">{{formatedDate(asset.created_datetime)}}</span> -->
                                <span v-if="Object.keys(asset).includes('created_datetime') && asset.created_datetime.length > 0" :title="getDateAndTimeInConfiguredFormat(asset.created_datetime)">{{checkIsTodayoryesterdayDate(asset.created_datetime)?getDateAndTimeInConfiguredFormat(asset.created_datetime, true) : getDateAndTimeInConfiguredFormat(asset.created_datetime)}}</span>
                                <span v-else class="validationmessage">No Data found</span>
                            </td>

                            <td>
                                <span v-if="Object.keys(asset).includes('size') && asset.size != null && asset.size != undefined">{{getConvertedFileSize(asset.size)}}</span>
                                <span v-else class="validationmessage">No Data found</span>
                            </td>

                            <td>
                                <span v-if="Object.keys(asset).includes('duration') && asset.duration">{{getHumanReadableDuration(asset.duration)}}</span>
                                <span v-else class="validationmessage"> - </span>
                            </td>

                            <td>
                                <span style='padding-inline-end:10px' v-if="Object.keys(asset).includes('path') && asset.path.length > 0">{{asset.path}}</span>
                                <span v-else class="validationmessage">No Data found</span>
                            </td>

                            <td>
                                <template v-if="Object.keys(asset).includes('catalog_path') && asset.catalog_path.length > 0">
                                    <span v-for="(catalog,index) in asset.catalog_path" :key="catalog" style="padding-inline-end:10px;word-wrap: break-word;max-width: 50px;">
                                        {{ catalog.replace(/^catalog:\/\/0\//, '') }}
                                        <span v-if="index !=  asset.catalog_path.length - 1">, </span>
                                    </span>
                                </template>
                                <span v-else class="validationmessage">No Data found</span>
                            </td>

                            <td>
                                <span v-if="Object.keys(asset).includes('state') && asset.state != null && asset.state != undefined" style="text-align:center;display: flex;justify-content: center;" class="capitalize">{{asset.state == 'MARK FOR DELETE'?'MARKED FOR DELETE':asset.state}}</span>
                                <span v-else class="validationmessage">No Data found</span>
                            </td>
                            <svg v-if="asset.state && ['OUTDATED','READY'].includes(asset.state)" @click.stop.prevent="markForDelete(asset)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#eee" class="bi bi-trash parent-comment-delete" viewBox="0 0 16 16" style="margin-inline-start:10px;">
                                <title>Mark for delete</title>
                                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                                <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                            </svg>
                        </tr>
                    </template>

                </tbody>
                <tbody v-else>
                        <tr>
                            <td colspan="6">No Data Found</td>
                        </tr>
                    </tbody>  
            </table> 
        </div>  
        <div>
            <pagination
                v-model="page"
                :records="totalDuplicatesFiles"
                :per-page="perPage"
                @paginate="paginate"
                :options="options"
                style="margin-top:10px"
            />    
        </div>         
    </div>
</template>   

<script>
    import { mapActions, mapGetters, mapMutations } from "vuex";
    import Utils from "../../components.utils.js";  
    import buttonsTopbar from "./headerbar.vue";
    import Pagination from "vue-pagination-2";
    import FiltersTopbar from "./filtersBar.vue";
    export default {
        data(){
                return{
                    page: 1,
                    totalPages: -1,
                    totalDuplicatesFiles: -1,
                    perPage: -1,
                    duplicatesReportData:[],
                    duplicatesUserMap:[],
                    userNameIdMap:{},
                    time1:null,
                    selectedUserInfo:{},
                    selectedUserGroupInfo:{},
                    filterBy:{},
                    userListFromAutocomplete:[],
                    userGroupListFromAutocomplete:[],
                    searchByUser:"",
                    showUserFilter:false,
                    showUserGroupFilter:false,
                    searchByGroup:"",
                    fileNameFilter:"",
                    // filterByAction:{
                    //     state:"All",
                    //     job_name:"All"
                    // },
                    options:{chunk:5},
                    selectedJobName:"All",
                    searchKey :"",

                    payloadParams : {},
                    activeIndex:null,
                    randomColor:'',
                    firstIndex:{}
                } 
        },  
        components:{
            // 'k-progress': KProgress,
            pagination: Pagination,
            "button-top-bar":buttonsTopbar,
            "filters-top-bar":FiltersTopbar,
        },
        methods:{
            getHumanReadableDuration(duration){
                return Utils.getDurationInSeconds(duration)
            },
            changeSelectedReportComponent(filtersdata){
                this.payloadParams = filtersdata;
                this.refreshDuplicateReport(false);
            },
            refreshDuplicateReport(isPageClick = false) {
                let payload = {}
                if(isPageClick){
                     this.payloadParams.page = this.page
                }
                
                payload.params = this.payloadParams;
                if(payload.params.user_id)delete payload.params.user_id
                if(payload.params.download)delete payload.params.download
                this.getDuplicateReports(payload).then((data) => {
                    this.duplicatesReportData = data.duplicates;
                    this.totalPages = data["page_count"];
                    this.totalDuplicatesFiles = data["total_duplicates"];
                    this.perPage = data["duplicates_per_page"];
                }); 
            },
            isPrivilegeExists(privilegeName){
                return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege(), privilegeName);
            },

            markForDelete(fileInfo){
                let payload = {};
                payload._id = fileInfo._id
                payload.job_name = "Mark For Delete";
                payload.element_type = "file";
                payload.file_type = 'file';
                payload.from_context = "bins";
                payload.size = fileInfo.size;
                payload.file_uid = fileInfo.file_uid;
                payload.parent_id_path = fileInfo.parent_id_path;
                payload.version_id = fileInfo.version_id;
                payload.asset_id = fileInfo.asset_id;
                payload.resource_name = fileInfo.file_name || fileInfo.dir_name;
                this.createNewJob(payload).then((data) => {
                    if (data.statusCode == 200) {
                        this.$toast.success(data.message);
                    } else {
                        this.$toast.error(data.message);
                    }
                })
            },
            downloadDuplicatesReportData() {
                // let filePath = url;
                let payload = {};
                payload.params =this.payloadParams;
                payload.params['download'] = true;
                if(payload.params.user_id)delete payload.params.user_id
                if(payload.params.page)delete payload.params.page
                this.$toast.info("You will be notified once the report is ready to download");
                this.downloadDuplicatesReportFromServer(payload).then(() => {
                    console.log("Downloading report")
                // const blob = new Blob([response.data], {
                //     type: "application/vnd.csv",
                // });
                // const link = document.createElement("a");
                // link.href = URL.createObjectURL(blob);
                // link.setAttribute(
                //     "download",
                //     response.headers["content-disposition"].split("filename=")[1]
                // );
                // document.body.appendChild(link);
                // link.click();
                })
                .catch(console.error);
            },

            // getConvertedFileSize(size){
            //     return Utils.getConvertedFileSize(size);
            // },  

            getConvertedFileSize(size){
                return Utils.getConvertedFileSize(size);
            }, 

            formatedDate(date){
                return Utils.getDateTimeFormat(date);
            },
            getUserNameFromId(userId){
                let username = ""
                if(this.ingestUserMap.length > 0){
                    let usermap = this.ingestUserMap.filter((usersMap)=>(usersMap.user_id == userId))
                    if(usermap != undefined &&  typeof usermap != "undefined" && usermap[0]!= undefined){
                      
                        username = usermap[0].username
                    }
                }
                return username
            },

            paginate() {
                this.refreshDuplicateReport(true);
            },
            getRandomColorFromUtils(index1){
                if(!this.firstIndex[index1]){
                    this.firstIndex[index1] = Utils.getRandomColor();
                }
                return this.firstIndex[index1]
            },
            setRandomColor(){
                this.getRandomColorFromUtils();                    
            },
            handleDuplicateCreatedNotification(notification){
                notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
                if(notification.message){
                    this.refreshDuplicateReport(false)
                }
            },
            handleJobStatusUpdatedNotification(notification){
                notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
                if(notification.message){
                    for(let v = 0; v < this.duplicatesReportData.length; v++){
                        let vIndex = this.duplicatesReportData[v].assets.findIndex(e => e.file_uid == notification.message.data.file_uid)
                        if(vIndex > -1){
                            if(notification.message.job_name == 'Mark For Delete'){
                                this.$set(this.duplicatesReportData[v].assets[vIndex], "state", 'MARK FOR DELETE')
                            }
                        }
                    }
                }
                
            },
            registerforWebsocketNotifications(){
                this.addWSEventListener({
                    eventname:['DUPLICATE_CREATED'],
                    callback:this.handleDuplicateCreatedNotification,
                    parent: "archiveReports"})

                this.addWSEventListener({
                    eventname:['JOB_STATUS_UPDATE'],
                    callback:this.handleJobStatusUpdatedNotification,
                    parent: "archiveReports"})
            },
            unRegisterforWebsocketNotifications(){
                this.removeWSEventListener({
                    eventname:['DUPLICATE_CREATED'],
                    callback:this.handleDuplicateCreatedNotification,
                    parent: "archiveReports"})
                
                this.removeWSEventListener({
                    eventname:['JOB_STATUS_UPDATE'],
                    callback:this.handleJobStatusUpdatedNotification,
                    parent: "archiveReports"})
            },

            ...mapActions("retrieveReports", ["getDuplicateReports","downloadDuplicatesReportFromServer"]),
            ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
            ...mapGetters("users",["getLoggedInUser","getLoggedInUserId","getLoggedInUserPrivilege"]),
            ...mapActions("jobs", ["createNewJob"]),
        },
        beforeDestroy(){
            this.unRegisterforWebsocketNotifications()
        },
        created(){
            this.refreshDuplicateReport(false);
            this.registerforWebsocketNotifications()
        },
        computed: {
            currentDownloadReportProperties() {
                return { reportContext : "duplicates"};
            },
        },
    
    }
</script>

<style scoped lang="scss">
     $table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;

    .ingest-report-div{
        padding: 0px 30px 10px 30px;
        height: calc(100% - 115px);
        overflow: auto;
    }

    .table-scroll thead th {
        position: sticky;
        top: 0;
        background: $primary-background;
        z-index: 9;
    }

    th, td{
        text-align: start;
    }

    tbody tr{
        border-bottom: $secondary-border-color;
    }

    .validationmessage{
        color: $dull-text-color;
    }
    .each-row-actions{
        width: 200px;
        position: absolute;
        display: inline-flex;
        inset-inline-end: 0px;
        top: 0px;
        justify-content: end;
    }

    .comm-user-row:hover {
    :not(.user-name), :not(.comm-user-row:last-child), :not(.user-actions-icon){
        color: $active-blue;
        background: $bg-color-on-hover;
    }
    td:first-child {
        :not(.user-name){
        text-decoration: underline;
        }
    }
    }
    .primary-btn-style{
        width: 100%;
        text-align: end;
        button{
            height: 38px;
            width: 70px;
            font-size:14px;
        }
        .text-light:hover{
        text-decoration: underline;
        }
    }
    .table-scroll {
        /*width:100%; */
        border: none !important;
        /* Decoration */
        border-spacing: 0;
        thead {
            color: $dull-text-color !important;
            position: relative;
            width: 100%;
            th{
            position: sticky;
            top: 0;
            background:$primary-background;
            z-index:9;
            }
        }
        tbody {
            width: 100%;
            overflow: auto;
            font-weight: 500;
            tr{
            height:60px;
            }
        }
    }

    .search-bar-comm-style {
        height: 30px;
        position: relative;
        input {
            border: $border-color !important;
            position: absolute;
            top: 12%;
            inset-inline-start:5%;
            height: 38px !important;
            padding-inline-start: 8%;
        }
        svg {
            position: absolute;
            inset-inline-start:24px;
            top: 34%;
        }
    }

    .ccomm-logs-row:hover{
        .parent-row-delete,  .parent-row-edit, .parent-row-logout{
            visibility: visible;
        }
    }

    .parent-row-delete,  .parent-row-edit, .parent-row-logout{
        visibility: hidden;
    }
    .value-style {
        color: $text-color;
        width: 97%;
        text-align: start;
        padding-top: 3px;
        padding-bottom: 3px;
        padding-inline-end: 5px;
    }

    .filter-fields-in-logs div{
        display:inline-flex;
        div.comm-div{
            display:inline-flex;
            width:25%;
            // padding-top:7px;
            position: relative;
            // inset-inline-end :2%;
            label{
            color:$dull-text-color;
            position: relative;
            inset-inline-end: 5px;
            width:30%;
            text-align:end;
            top:2px;
            }
            select,input{
            width:70%;
            height:27px;
            border:$border-color !important;
            }
        }
    }

    li {
      width: 25%;
      display: inline-flex;
      // margin-bottom: 20px;
    }

    .config-label {
        width: 26% !important;
        text-align: end;
        color: #757575;
        word-break: break-word;
        position: relative !important;
        top: 9px !important;
    }
    
    .config-value {
        margin-inline-start: 4px;
        width: 75% !important;
        display:grid;
        svg{
            position: relative;
            top: 9px;
            margin-inline-start: 10px;
        }
    }

    .show-delete-icon:hover{
        .parent-comment-delete,  .parent-comment-view{
            visibility: visible;
        }
    }

    .parent-comment-delete, .parent-comment-view{
        margin-inline-start: 10px;
        position: absolute;
        inset-inline-end: 0px;
        z-index: 1;
        background: #525252;
        border: 1px solid #262626;
        width: 55px;
        height: 44px;
        padding: 12px;
        top: 0px;
        border-radius: 0px 5px 5px 0px;
        visibility: hidden;
    }
    ::v-deep {
         .page-item.disabled .page-link {
    background-color: $secondary-background-color !important;
    border: $border-color !important;
    // border: none;
  }
  .page-item.active .page-link {
    background-color: $secondary-background-color !important;
    // border: none !important;
    border: $border-color !important;
    color: $active-blue;
    z-index: 0 !important;
  }
  .page-link {
    background-color: $secondary-background-color !important;
    border: $border-color !important;
    // border: none !important;
    color: $text-color;
    padding: 5px !important;
  }
  .page-link:hover {
    background-color: $bg-color-on-hover !important;
  }
  .pagination {
    float: inline-end;
    margin-bottom: 0px !important;
    margin-inline-end: 8px;
  }
  .VuePagination__count {
    color: $secondary-text-color !important;
    margin-bottom: 0px !important;
    font-size: 12px;
    margin-inline-end: 7px;
    margin-top: 1px;
    float: inline-end;
    position: relative;
    margin-inline-start: 5px;
    top: 5px;
  }
  .VuePagination__pagination-item {
    font-size: 14px;
    width: 27px;
  }
  .VuePagination__pagination-item-prev-chunk {
    display: none;
  }
  .VuePagination__pagination-item-next-chunk {
    display: none;
  }

  .VuePagination__pagination-item-prev-page {
    width: 50px !important;
  }

  .VuePagination__pagination-item-next-page {
    width: 50px !important;
  }

  .VuePagination__pagination-item-next-page a:before {
    width: 50px;
    content: "next ";
  }

  .VuePagination__pagination-item-prev-page a:after {
    width: 50px;
    content: " prev";
  }
  .v-list {
    padding: 0px !important;
  }
  .v-list-item {
    text-align: start;
    border: $secondary-border-color !important;
    min-height: 37px !important;
    padding: 0 10px !important;
    font-size: 12px !important;
    .v-list-item__title {
      font-size: 14px !important;
      color: $text-color !important;
    }
  }
  .v-menu__content {
    width: 190px !important;
  }
}  

.show-delete-icon{
    position:relative;
}

::-webkit-scrollbar {
    width: 8px;
    height:8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: $secondary-background-color;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #363636;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: $bg-color-on-hover;
  }

  .capitalize{
    text-transform: lowercase !important;
    }
    .capitalize {
        text-transform: capitalize !important;
    }
  
</style>